import React, { FC } from 'react';
import classNames from 'classnames';
import cls from './Resizer.module.css';

export const Resizer = ({ onResize, scrollDiagram }) => {
    const handleMouseMove = (event) => {
        const distanceFromGant = $('#gant').offset();
        onResize(event.clientX - distanceFromGant.left);
        document.body.style.cursor = 'col-resize';
    };

    window.addEventListener('mouseup', () => {
        window.removeEventListener('mousemove', handleMouseMove);
        document.body.style.cursor = 'auto';
    });

    return (
        <div className={cls.wrapper}>
            <div className={cls.backToToday} onClick={() => scrollDiagram()}>
                {i18next.t('PositionItem.return.backToToday.text')}
            </div>
            <div
                className={classNames(cls.Resizer)}
                onMouseDown={(e) => {
                    window.addEventListener('mousemove', handleMouseMove);
                }}
            ></div>
        </div>
    );
};
